import { BookAndPageNumberUIProvider } from "./BookAndPageNumberUIContext";
import { BookAndPageNumberCard } from "./BookAndPageNumberCard";

export function BookAndPageNumberPage({
  term,
  date,
  dateEnd,
  sectionId,
  studentId
}) {  
  return (
    <BookAndPageNumberUIProvider bookAndPageNumberParameters={{ term, date, dateEnd, sectionId, studentId }}>
      <BookAndPageNumberCard />
    </BookAndPageNumberUIProvider>
 );
}